<template>
  <div class="anti-loss-popup-wrap">
    <div class="anti-loss-wrap" :class="{ 'active': show}">
      <div class="al-title" :class="langkey"></div>
      <p class="al-subtitle" v-html="$t('subtitle_anti_loss', [`<span>${$t('subtitle_anti_loss_slot')}</span>`])"></p>
      <div class="gift-code">
        <span>
          {{ $t('text_giftcode_anti_loss') }}
          <em>PLAYSOSONWEB</em>
        </span>
        <a href="javascript:;" class="btn-copy" @click="doCopy('PLAYSOSONWEB')"></a>
      </div>
      <div class="awards-list"></div>
      <!-- <p class="count-down" :class="{ 'hide': countDownOver }">{{ $t('text_countdown_anti_loss') }} <span>{{ countDown }}{{ $t('text_sec_anti_loss') }}</span></p> -->
      <a href="javascript:;" class="btn-close" @click="handleClose"></a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PopupAntiLoss',
  data () {
    const langkey = this.$i18n.locale
    return {
      langkey,
      show: true,
      timer: null,
      countDown: 30,
      countDownOver: false,
      countDownTimer: null
    }
  },
  computed: {
    ...mapState({
      userInfo: 'userInfo'
    })
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (!this.userInfo.isNew) {
        this.$emit('delPopup', 'PopupAntiLoss')
      }
    },
    showPopup () {
      this.$utils.consoleLog('anti loss popup - showPopup')
      clearTimeout(this.timer)
      this.timer = null
      this.show = true
      this.setCountDown()
      document.getElementById('app').removeEventListener('mouseleave', this.showPopup)
    },
    doCopy (value) {
      this.$utils.copyToClipboard(value)
    },
    handleClose () {
      this.show = false
      this.stopCountDown()
      this.$emit('closed')
    },
    setCountDown () {
      const _this = this
      this.countDownTimer = setInterval(() => {
        if (_this.countDown <= 0) {
          _this.stopCountDown()
        } else {
          _this.countDown--
        }
      }, 1000)
    },
    stopCountDown () {
      this.countDownOver = true
      clearInterval(this.countDownTimer)
    }
  },
  beforeDestroy () {
    this.timer && clearTimeout(this.timer)
    this.timer = null
    this.countDownTimer && clearTimeout(this.countDownTimer)
    this.countDownTimer = null
    document.getElementById('app').removeEventListener('mouseleave', this.showPopup)
  }
}
</script>

<style lang="scss" scoped>
.anti-loss-popup-wrap{
  font-family: 'bbsk';
}
.anti-loss-wrap{
  width: 1300px;
  height: 740px;
  padding: 190px 50px 0 600px;
  margin-left: -6.25%;
  position: fixed;
  top: 50%;
  left: 200%;
  opacity: 0;
  color: #fff;
  transform: translate(-50%, -50%) scale(calc(var(--unit-num)));
  transition: opacity .3s;
  background-image: url(~@/assets/img/popup_anti_loss/bg_anti_loss.png);
  background-size: 100% 100%;
  &.active{
    opacity: 1;
    left: 50%;
  }
}
.al-title{
  width: 100%;
  height: 60px;
  margin-bottom: 14px;
  font-size: 60px;
  color: #ffff70;
  text-align: center;
  position: relative;
  background: url(~@/assets/img/popup_anti_loss/text_title.png) no-repeat center center;
  background-size: contain;
  &.zh_cn{ background-image: url(~@/assets/img/popup_anti_loss/text_title_zh_cn.png); }
  &.zh_tw{ background-image: url(~@/assets/img/popup_anti_loss/text_title_zh_cn.png); }
  &.fr{ background-image: url(~@/assets/img/popup_anti_loss/text_title_fr.png); }
  &.ja{ background-image: url(~@/assets/img/popup_anti_loss/text_title_ja.png); }
  &.ko{ background-image: url(~@/assets/img/popup_anti_loss/text_title_ko.png); }
  &.de{ background-image: url(~@/assets/img/popup_anti_loss/text_title_de.png); }
}
.al-subtitle{
  width: 100%;
  height: 80px;
  margin-bottom: 32px;
  line-height: 40px;
  font-size: 30px;
  color: #fff;
  text-align: center;
  ::v-deep(span){
    color: #ffa000;
  }
}
.gift-code{
  width: 100%;
  height: 38px;
  margin-bottom: 12px;
  line-height: 44px;
  font-size: 30px;
  color: #fff;
  text-align: center;
  display: flex;
  justify-content: center;
  em{
    color: #ffa000;
    user-select: all;
    position: relative;
    font-style: normal;
  }
  .btn-copy{
    width: 24px;
    height: 100%;
    background: url(~@/assets/img/popup_anti_loss/btn_copy.png) no-repeat center 10px ;
    background-size: 16px auto;
    &:active{
      transform: scale(.9);
    }
  }
}
.awards-list{
  width: 100%;
  height: 98px;
  margin-bottom: 40px;
  background: url(~@/assets/img/popup_anti_loss/award_list.png) no-repeat center center;
  background-size: contain;
}
.count-down{
  text-align: right;
  font-size: 22px;
  transition: opacity .3s;
  position: relative;
  right: -20px;
  span{
    font-size: 28px;
    color: #ffa000;
  }
  &.hide{
    opacity: 0;
  }
}
.btn-close{
  width: 44px;
  height: 44px;
  position: absolute;
  top: 167px;
  right: 30px;
  background: url(~@/assets/img/popup_anti_loss/btn_close.png) no-repeat center center;
  background-size: 24px 24px;
}
</style>
